export default __webpack_public_path__ + "6c12de646cafad03d23eb4ba721ef384.png";